import React from 'react';
import PropTypes from 'prop-types';
import SectionWrapper from '../SectionWrapper';
import { Headline, Subheadline, Row, BoxHeadline, BoxImage, BoxContent, StyledCustomBox } from './GHValuePropsCustomBox.styles'


const setTextColorStyle = ( textColor ) => {
  //console.log( "setTextColorStyle", textColor);
  return textColor ? { color: textColor } : {};
}

const GHValuePropsBox = (props) => (
  <SectionWrapper
      className="value-prop-section"
      bottomGraphic={props.bottomGraphic}
      bottomGraphicColor={props.bottomGraphicColor}
      bottomGraphicNegativeColor={props.bottomGraphicNegativeColor}
      backgroundColor={props.backgroundColor}
      maxWidth={props.maxWidth}
      style={props.style}
  >
    {props.headline ? <Headline style={setTextColorStyle(props.textColor)}>{props.headline}</Headline> : ""}
    {props.subheadline ? <Subheadline style={setTextColorStyle( props.textColor )}>{props.subheadline}</Subheadline> : ""}
    <Row className="row" spacingBottom={props.spacingBottom} theme={props.theme}>
      {props.valueProps?.map((value, i) => {
        return(
          <CustomBox
            key={i}
            layout={props.layout}
            imageSrc={value.imageSrc}
            alt={value.alt === undefined ? '' : value.alt}
            headline={value.headline}
            subheadline={value.subheadline}
            imageSize={value.imageSize}
            imageWrapperHeight={props.imageWrapperHeight}
            maxWidth={props.maxPropWidth}
            perRow={props.propsPerRow}
            textColor={props.textColor}
            theme={props.theme}
          />
        )
      })}
    </Row>
  </SectionWrapper>
);

GHValuePropsBox.propTypes = {
  headline: PropTypes.string,
  subheadline: PropTypes.string,
  textColor: PropTypes.string,
  theme: PropTypes.string,
  style: PropTypes.string,
  imageWrapperHeight: PropTypes.string,
  layout: PropTypes.oneOf(["vertical", "horizontal"]).isRequired,
  valueProps: PropTypes.arrayOf(PropTypes.shape({
    imageSrc: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    subheadline: PropTypes.string.isRequired,
    alt: PropTypes.string,
    imageSize: PropTypes.objectOf( {
      width: PropTypes.string,
      maxWidth: PropTypes.string,
      height: PropTypes.string,
      maxHeight: PropTypes.string
    })
  })).isRequired,
  backgroundColor: PropTypes.string,
  bottomGraphic: PropTypes.bool,
  bottomGraphicColor: PropTypes.string,
  propsPerRow: PropTypes.number,
  maxPropWidth: PropTypes.number,
  spacingBottom: PropTypes.string,
};

GHValuePropsBox.defaultProps = {
  headline: null,
  subheadline: null,
  textColor: null,
  theme:'default',
  style: '',
  imageWrapperHeight: '',
  valueProps: null,
  backgroundColor: 'white',
  bottomGraphic: false,
  bottomGraphicColor: '#ff8800',
  propsPerRow: 3,
  maxPropWidth: null,
  spacingBottom: null,
};

export default GHValuePropsBox;


/**
 * @param {string} layout = [vertical | horizontal] determines the layout of the value props
 * @param {string} imageSrc = image src url
 * @param {string} alt = image alt
 * @param {string} headline = headline text
 * @param {string} subheadline = subheadline text
 */
const CustomBox = ({layout, imageSrc, alt, headline, subheadline, perRow, imageSize, imageWrapperHeight, textColor, theme, maxWidth}) => {

  alt = headline === '' ? alt : headline;

  const cssClassName = theme === 'default' ? `col-sm-12 col-md-${12 / perRow}` : '';
  let imageWrapperStyle = imageWrapperHeight ? {minHeight: imageWrapperHeight} : {};

  return(
    <StyledCustomBox maxWidth={maxWidth} layout={layout} className={cssClassName} imageSize={imageSize} theme={theme}>
      <div style={imageWrapperStyle}><BoxImage src={imageSrc} alt={`${alt}`}/></div>
      <BoxContent>
        {headline && <BoxHeadline style={setTextColorStyle(textColor)}>{headline}</BoxHeadline> }
        {subheadline && <p className="value-prop__subheadline" style={setTextColorStyle(textColor)}>{subheadline}</p>}
      </BoxContent>
    </StyledCustomBox>
  )
}

CustomBox.propTypes = {
  layout: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  subheadline: PropTypes.string.isRequired,
  imageSize: PropTypes.arrayOf( PropTypes.shape( {
    width: PropTypes.string,
    maxWidth: PropTypes.string,
    height: PropTypes.string,
    maxHeight: PropTypes.string
  } ) )
};

CustomBox.defaultProps = {
  layout: "vertical",
  imageSrc: "https://via.placeholder.com/350x200",
  headline: 'Value prop headline',
  subheadline: null,
  imageSize: {
    width: null,
    maxWidth: null,
    height: null,
    maxHeight: null

  }
};
